import { useEffect, useRef, useState } from "react";
import "./UwMedicalSingle.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { motion } from "framer-motion";
import moment from "moment";
import { FaSave } from "react-icons/fa";
import RefreshIcon from "@mui/icons-material/Refresh";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import TagIcon from '@mui/icons-material/Tag';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { TbCertificate } from "react-icons/tb";
import EmailIcon from '@mui/icons-material/Email';
import { MdOutlineMenuOpen } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { GridLoader, ScaleLoader } from "react-spinners";
import { addDaysToMongoDate, sanitizeText } from "../../../utils/genericFunctions.js";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";



const UwMedicalSingle = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [additionalActionsMenu, setAdditionalActionsMenu] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const navigate = useNavigate();
  const actionsMenuRef = useRef(null);
  const location = useLocation();
  const parts = location.pathname.split("/");

  // email component 
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);

  // reports
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

  const [medicalRequestId, setMedicalRequestId] = useState(parts[parts.length - 1]);
  const [medicalRequestData, setMedicalRequestData] = useState(null);
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [insuredDetails, setInsuredDetails] = useState(null);
  const [facilityDetails, setFacilityDetails] = useState(null);
  const [rqCode, setRqCode] = useState(null);
  const [rqBizUnit, setRqBizUnit] = useState(null);
  const [rqMrCode, setRqMrCode] = useState(null);
  const [rqNarration, setRqNarration] = useState(null);
  const [rqStatus, setRqStatus] = useState(null);
  const [rqInsuredAentCode, setRqInsuredAentCode] = useState(null);
  const [rqInsuredEntCode, setRqInsuredEntCode] = useState(null);
  const [rqFacilityAentCode, setRqFacilityAentCode] = useState(null);
  const [rqFacilityEntCode, setRqFacilityEntCode] = useState(null);
  const [rqExpectedReturn, setRqExpectedReturn] = useState(null);
  const [rqDoneOn, setRqDoneOn] = useState(null);
  const [rqActions, setRqActions] = useState(null);
  const [rqTests, setRqTests] = useState(null);
  const [nextAction, setNextAction] = useState("None");
  const [saveEnabled, setSaveEnabled] = useState("Y");
  const [medicalTestsToPerform, setMedicalTestsToPerform] = useState(null);
  const [timeline, setTimeline] = useState(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
        setAdditionalActionsMenu(false);
      }
    }

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const handleMedicalRequestData = (name, value) => {
    setMedicalRequestData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const goBack = () => {
    // navigate(-1, { state: { shouldFetchClients: false } });
    navigate(-1);
  };


  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = async () => {
    try {
      if (objectToAction.new_doc_status === "Validated") {
        const res = await newRequest.put(
          `/uwMedicalRequest/upd/${medicalRequestId}`, { rq_status: "Validated" });
        // add trace
        const trace_res = await newRequest.post(
          "/uwMedicalRequest/addRequestAction",
          {
            request_docid: medicalRequestId,
            action_code: "changed status",
            action_text: "changed request status to Validated",
          }
        );
        fetchMedicalRequest();
      } else if (objectToAction.new_doc_status === "Approved") {
        const res = await newRequest.put(
          `/uwMedicalRequest/upd/${medicalRequestId}`, { rq_status: "Approved" });
        // add trace
        const trace_res = await newRequest.post(
          "/uwMedicalRequest/addRequestAction",
          {
            request_docid: medicalRequestId,
            action_code: "changed status",
            action_text: "changed request status to Approved",
          }
        );
        fetchMedicalRequest();
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const fetchMedicalRequest = async () => {
    try {

      const res = await newRequest.post(
        "/uwMedicalRequest/findById", { request_docid: medicalRequestId });
      setMedicalRequestData(res.data);

      // console.log(`${JSON.stringify(res.data?.medical_tests_xx, null, 2)}`);

      if (res.data) {
        setDocumentEnabled(res.data.document_enabled_xx);
        setInsuredDetails(res.data.insured_details_xx);
        setFacilityDetails(res.data.facility_details_xx);
        setRqCode(res.data.rq_code);
        setRqNarration(res.data.rq_narration);
        setRqStatus(res.data.rq_status);
        setRqActions(res.data.rq_actions);
        setRqTests(res.data.rq_tests);
        setMedicalTestsToPerform(res.data.medical_tests_xx);
        setTimeline(res.data.request_actions_xx);
        setSaveEnabled(res.data.save_enabled_xx);
        setNextAction(res.data.next_action_xx);


        if (res.data.rq_expected_return) {
          const formattedDate = moment(res.data.rq_expected_return).format("YYYY-MM-DD");
          setRqExpectedReturn(formattedDate);
        }
        if (res.data.rq_done_on) {
          const formattedDate = moment(res.data.rq_done_on).format("YYYY-MM-DD");
          setRqDoneOn(formattedDate);
        }

        if (res.data.insured_details_xx) {
          setRqInsuredEntCode({
            ent_email: res.data.insured_details_xx.ent_email,
            ent_phone_no: res.data.insured_details_xx.ent_phone_no,
            ent_status: res.data.insured_details_xx.ent_status,
            aent_name_xx: res.data.insured_details_xx.aent_name_xx,
            ent_code: res.data.insured_details_xx.ent_code,
            ent_aent_code: res.data.insured_details_xx.ent_aent_code,
            ent_name: res.data.insured_details_xx.ent_name,
            value: res.data.insured_details_xx.ent_code,
            label: res.data.insured_details_xx.ent_name
          });
          setRqInsuredAentCode(res.data.rq_insured_aent_code);
        }

        if (res.data.facility_details_xx) {
          setRqFacilityEntCode({
            ent_email: res.data.facility_details_xx.ent_email,
            ent_phone_no: res.data.facility_details_xx.ent_phone_no,
            ent_status: res.data.facility_details_xx.ent_status,
            aent_name_xx: res.data.facility_details_xx.aent_name_xx,
            ent_code: res.data.facility_details_xx.ent_code,
            ent_aent_code: res.data.facility_details_xx.ent_aent_code,
            ent_name: res.data.facility_details_xx.ent_name,
            value: res.data.facility_details_xx.ent_code,
            label: res.data.facility_details_xx.ent_name
          });
          setRqFacilityAentCode(res.data.rq_facility_aent_code);
        }

        if (res.data.rq_biz_unit) {
          setRqBizUnit({
            unit_type: res.data.bizunit_type_xx,
            value: res.data.rq_biz_unit,
            label: res.data.bizunit_name_xx
          });
        }

        if (res.data.rq_mr_code) {
          setRqMrCode({
            value: res.data.rq_mr_code,
            label: res.data.rq_mr_code_xx
          });
        }
      }

    } catch (err) {
      console.log(err);
    }
  };

  const [medicalReviewClasses, setMedicalReviewClasses] = useState([]);
  const fetchReviewClasses = async () => {
    try {
      const res = await newRequest.post("/uwMedicalReview/findAll");

      const options = res.data.map((mc) => ({
        value: mc.mr_code,
        label: mc.mr_name,
      }));

      setMedicalReviewClasses(options);

    } catch (error) {
      console.error("Error fetching medical review classes :", error);
    }
  };

  const [branches, setBranches] = useState([]);
  const fetchBranches = async () => {
    try {
      const res = await newRequest.post(
        "/orgUnit/findAll",
        {
          unit_org_code: currentUser.usr_org_code,
          unit_status: "Active"
        }
      );

      const options = res.data.map((branch) => ({
        unit_type: branch.unit_type,
        value: branch.unit_code,
        label: branch.unit_name,
      }));

      setBranches(options);

    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const saveRecord = async (e) => {
    // e.preventDefault();
    try {

      if (!rqInsuredEntCode?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select insured!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!rqFacilityEntCode?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select facility!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (medicalRequestId !== "new") {
        const { rq_actions, rq_tests, insured_details_xx, facility_details_xx, request_actions_xx, updated_by_name_xx, updated_by_photo_url_xx, ...updatedRequest } = medicalRequestData;
        const res = await newRequest.put(
          `/uwMedicalRequest/upd/${medicalRequestId}`,
          updatedRequest
        );
      } else {

        if (!rqMrCode?.value) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please select medical tests template!`);
          setIsNotifyDialogOpen(true);
          return;
        }

        let generatedDocNo = null;
        if (!rqCode) {
          const medicalReqNo = await newRequest.post(
            "/orgNumgen/gen",
            {
              gen_org_code: currentUser.usr_org_code,
              gen_type: "Medical Request",
            },
          );
          generatedDocNo = medicalReqNo.data;
        } else {
          generatedDocNo = rqCode;
        }
        // console.log(`generatedDocNo ${JSON.stringify(generatedDocNo, null, 2)}`);
        const res = await newRequest.post(
          "/uwMedicalRequest/add",
          {
            rq_code: generatedDocNo,
            rq_narration: rqNarration,
            rq_status: rqStatus,
            rq_biz_unit: rqBizUnit?.value,
            rq_insured_aent_code: rqInsuredEntCode?.ent_aent_code,
            rq_insured_ent_code: rqInsuredEntCode?.value,
            rq_facility_aent_code: rqFacilityEntCode?.ent_aent_code,
            rq_facility_ent_code: rqFacilityEntCode?.value,
            rq_expected_return: rqExpectedReturn,
            rq_done_on: rqDoneOn,
            rq_mr_code: rqMrCode?.value,
            rq_actions: [
              {
                action_code: "created",
                action_text: "created this request",
                action_by: currentUser.usr_id
              }
            ],
            rq_insured_name: rqInsuredEntCode?.label,
            rq_facility_name: rqFacilityEntCode?.label,
          }
        );
        setMedicalRequestId(res.data._id);
        setMedicalRequestData(res.data);
        fetchMedicalRequest();
        navigate(`/medical/${res.data._id}`, { replace: true });
      }
      setNotifyDialogTitle("Success!");
      setNotifyDialogText(`Details successfully saved`);
      setIsNotifyDialogOpen(true);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchEntityBySearch = async (inputValue, callback) => {
    try {
      const res = await newRequest.post(
        "/allEntity/search",
        {
          ent_org_code: currentUser.usr_org_code,
          search_input: inputValue,
        }
      );
      const options = res.data.map((entity) => ({
        ent_occupation: entity?.ent_occupation,
        ent_email: entity?.ent_email,
        ent_phone_no: entity?.ent_phone_no,
        ent_photo_url: entity?.ent_photo_url,
        ent_status: entity?.ent_status,
        aent_name_xx: entity?.aent_name_xx,
        ent_code: entity.ent_code,
        ent_aent_code: entity.ent_aent_code,
        ent_name: entity.ent_name,
        value: entity.ent_code,
        label: entity.ent_name,
      }));

      if (res.data.length === 0) {
        // No results found
        const noOptionsError = { message: "No Results found." };
        throw noOptionsError;
      }

      callback(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
      callback([]);
    }
  };

  useEffect(() => {
    if (medicalRequestId !== "new") {
      fetchMedicalRequest();
    } else {
      setDocumentEnabled("Y");
      setInsuredDetails(null);
      setFacilityDetails(null);
      setRqCode(null);
      setRqNarration(null);
      setRqStatus("New");
      setRqActions([]);
      setRqTests([]);
      setMedicalTestsToPerform([]);
      setTimeline([]);
      setSaveEnabled("Y");
      setNextAction("Validate");
      const currentDate = new Date();
      const formattedDate = moment(currentDate).format("YYYY-MM-DD");
      setRqExpectedReturn(addDaysToMongoDate(formattedDate, 5));
      setRqBizUnit({
        unit_type: currentUser.biz_unit_type_xx,
        value: currentUser.biz_unit_code_xx,
        label: currentUser.biz_unit_name_xx,
      });
    }
    fetchBranches();
    fetchReviewClasses();
  }, [medicalRequestId]);


  return (
    <motion.div
      className="medical-single"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="medical-single-main-wrapper">
          <div className="center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <h1 className="main-title">
                    {insuredDetails?.ent_name || "New"}
                  </h1>
                </div>
                <div className="navbar-right">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="left"
                    endIcon={<RefreshIcon className="button-icon" />}
                    onClick={fetchMedicalRequest}
                  >Refresh
                  </CustomLoadingButton>
                  {medicalRequestId !== "new" && (
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="none"
                      endIcon={<IoDocumentTextSharp />}
                      onClick={() => setReportsDialogOpen(true)}>
                      Reports
                    </CustomLoadingButton>
                  )}
                  {nextAction !== "None" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="none"
                      endIcon={<DragIndicatorIcon className="button-icon" />}
                      onClick={() => {
                        try {
                          let action_text = "";
                          let new_doc_status = "";
                          switch (rqStatus) {
                            case "New":
                              action_text = `Do you want to Validate this request?`;
                              new_doc_status = "Validated";
                              break;
                            case "Validated":
                              action_text = `Do you want to Approve this request?`;
                              new_doc_status = "Approved";
                              break;
                            case "Approved":
                              action_text = `Do you want to Approve this request?`;
                              new_doc_status = "Endorsed";
                              break;
                            case "Active":
                              action_text = `Do you want to Approve this request?`;
                              new_doc_status = "Endorsed";
                              break;
                            default:
                              action_text = "";
                              new_doc_status = "";
                          }

                          // if (!quoteData.pl_no && new_doc_status === "Endorsed") {
                          //   setNotifyDialogTitle("Note!");
                          //   setNotifyDialogText(
                          //     `You cannot endorse until you specify the Policy Number for this Risk note`
                          //   );
                          //   setIsNotifyDialogOpen(true);
                          //   return;
                          // }

                          // // UW1025 - User allowed complete document without commission
                          // if (getLimitValue("UW1025") === "N" && new_doc_status === "Validated" && parseFloat(quoteData?.commission_net_fc) === 0) {
                          //   setNotifyDialogTitle("Note!");
                          //   setNotifyDialogText(
                          //     `UW1025 - You cannot complete this document without specifying commission`
                          //   );
                          //   setIsNotifyDialogOpen(true);
                          //   return;
                          // }
                          setObjectToAction({
                            object_id: medicalRequestId,
                            action_text: action_text,
                            new_doc_status,
                          });
                          setIsConfirmDialogOpen(true);

                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {nextAction}
                    </CustomLoadingButton>}

                  {documentEnabled === "Y" &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="none"
                      endIcon={<FaSave />}
                      onClick={saveRecord}>
                      Save
                    </CustomLoadingButton>}
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<IoClose />}
                    onClick={goBack}>
                    Close
                  </CustomLoadingButton>
                  <div className="icon-container"
                    ref={actionsMenuRef}
                    onClick={(e) => {
                      try {
                        e.stopPropagation();
                        setAdditionalActionsMenu(!additionalActionsMenu)
                      } catch (error) {
                        console.log(error)
                      }
                    }}>
                    <MdOutlineMenuOpen className="icon" />
                    {additionalActionsMenu && (
                      <div className="dropdown">
                        <div className="dropdown-item">Form</div>
                        <div className="dropdown-item" >Under Review 1</div>
                        <div className="dropdown-item" >Under Review 2</div>
                        <div className="dropdown-item" >Under Review 3</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <hr className="separator-h" />
              {documentEnabled === "Y" &&
                <div className="request-details-wrapper" style={{ gap: "5px" }}>
                  <div className="input-item-with-label" style={{ display: "flex", flex: "1.5" }}>
                    <label htmlFor="rq_code" className="form-dropdown-label" style={{ width: "150px" }}>
                      REQUEST NO
                    </label>
                    <input
                      id="rq_code"
                      name="rq_code"
                      type="text"
                      placeholder="REQUEST NO"
                      value={rqCode}
                      className="form-input-item"
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        try {
                          setRqCode(e.target.value)
                          handleMedicalRequestData(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
                        } catch (error) {
                          console.log(error)
                        }
                      }}
                      disabled={rqCode}
                    />
                  </div>
                  <div className="input-item-with-label" style={{ display: "flex", flex: "2" }}>
                    <label htmlFor="rq_biz_unit">BIZ UNIT</label>
                    <Select
                      id="rq_biz_unit"
                      name="rq_biz_unit"
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width={"200px"}
                      value={rqBizUnit}
                      onChange={(selectedOption) => {
                        try {
                          handleMedicalRequestData("rq_biz_unit", selectedOption.value);
                          setRqBizUnit(selectedOption);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      options={branches}
                      isSearchable={true}
                      isDisabled={documentEnabled === "N"}
                      placeholder="BIZ UNIT"
                    />
                  </div>
                  <div className={`status ${rqStatus}`} style={{ display: "flex", flex: "1", alignItems: "center", justifyContent: "center", height: "36px" }}>
                    <h1 className="sub-title">{`STATUS ${rqStatus}`}</h1>
                  </div>
                </div>}
              {documentEnabled === "N" &&
                <div className="request-details-wrapper approved-doc">
                  <h1 className="sub-title">{`REQUEST NO ${rqCode}`}</h1>
                  <h1 className="sub-title">{`BIZ UNIT ${rqBizUnit?.label}`}</h1>
                  <h1 className="sub-title">{`STATUS ${rqStatus}`}</h1>
                </div>}
              {/* <span>{medicalRequestId}</span> */}
              {/* Insured details start here */}
              <ExpandableComponent
                title={insuredDetails?.ent_name || 'INSURED'}
                subtitle={<h1 className="main-title">INSURED</h1>}
                onSubtitleClick={null}
                bgColor="#fff"
                defaultExpanded={true}
              >
                <div className="form-details-wrapper insured">
                  <motion.div
                    className="entity-details-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="entity-details-wrapper">
                      <div className="entity-details-left">
                        {insuredDetails?.ent_photo_url ?
                          <img src={insuredDetails?.ent_photo_url} alt="" className="img" /> : <BrokenImageOutlinedIcon style={{ width: "80px", height: "80px" }} />}
                      </div>
                      <div className="entity-details-right">
                        <div className="name-row">
                          <h1 className="main-title">
                            {insuredDetails?.ent_name}
                          </h1>
                          {documentEnabled === "Y" &&
                            <h1 className="main-title">
                              {insuredDetails?.ent_occupation}
                            </h1>}
                          {documentEnabled === "Y" &&
                            <div className="input-item-with-label">
                              <AsyncSelect
                                id="rq_insured_ent_code"
                                name="rq_insured_ent_code"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="300px"
                                value={rqInsuredEntCode}
                                onChange={(selectedOption) => {
                                  try {
                                    handleMedicalRequestData("rq_insured_ent_code", selectedOption.value);
                                    handleMedicalRequestData("rq_insured_aent_code", selectedOption.ent_aent_code);
                                    handleMedicalRequestData("rq_insured_name", selectedOption.label);
                                    setInsuredDetails(selectedOption);
                                    setRqInsuredEntCode(selectedOption);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                loadOptions={fetchEntityBySearch}
                                isSearchable={true}
                                placeholder="Insured"
                              />
                            </div>}
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details" style={{ cursor: "pointer" }}
                            onClick={() => {
                              try {
                                setEmailData({
                                  to: insuredDetails?.ent_email,
                                  cc: "",
                                  bcc: "",
                                  subject: "",
                                  show_attach: "Y",
                                  attached_urls: [],
                                  binary_docs: [],
                                  doc_no: rqCode,
                                  doc_type: "Medical Request",
                                  doc_id: medicalRequestId,
                                  entity_codes: [rqInsuredEntCode?.value],
                                  search_string: rqInsuredEntCode?.label + "," + rqCode,
                                  carrierName: "",
                                  productName: "",
                                  clientName: rqInsuredEntCode?.label,
                                  riskNoteNo: rqCode,
                                  daysToRenewal: 0,
                                  expiryDate: null,
                                  insuredName: rqInsuredEntCode?.label,
                                  outstandingPremium: null,
                                  policyCurrency: null,
                                  policyNumber: null,
                                  policyPremium: null,
                                  policyPremiumTotal: null,
                                  policySumInsured: null,
                                  policyFromDate: null,
                                  policyToDate: null,
                                  tpt_category: []
                                });
                                setEmailDialogOpen(true);
                              } catch (error) {
                                console.log(error)
                              }
                            }}>
                            <EmailIcon className="icon" /> <h1 className="sub-title">{insuredDetails?.ent_email || "Missing"}</h1>
                          </span>
                          <span className="email-phone-details">
                            <LocalPhoneIcon className="icon" /> <h1 className="sub-title">{insuredDetails?.ent_phone_no || "Missing"}</h1>
                          </span>
                          <span className="email-phone-details">
                            <TbCertificate className="icon" /> <h1 className="sub-title">{insuredDetails?.aent_name_xx || ""}</h1>
                          </span>
                          <span className="email-phone-details"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              try {
                                navigate(`/entity/${insuredDetails?._id}`, {
                                  state: { shouldFetchClients: false },
                                });
                              } catch (error) {
                                console.log(error)
                              }
                            }}>
                            <TagIcon className="icon" /> <h1 className="sub-title">{insuredDetails?.ent_code}</h1>
                          </span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </ExpandableComponent>
              {/* insured details end here */}

              {/* facility details start here */}
              <ExpandableComponent
                title={facilityDetails?.ent_name || 'FACILITY'}
                subtitle={<h1 className="main-title">FACILITY</h1>}
                onSubtitleClick={null}
                bgColor="#fff"
                defaultExpanded={true}
              >
                <div className="form-details-wrapper facility">
                  <motion.div
                    className="entity-details-container"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="entity-details-wrapper">
                      <div className="entity-details-left">
                        {facilityDetails?.ent_photo_url ?
                          <img src={facilityDetails?.ent_photo_url} alt="" className="img" /> : <BrokenImageOutlinedIcon style={{ width: "80px", height: "80px" }} />}
                      </div>
                      <div className="entity-details-right">
                        <div className="name-row">
                          <h1 className="main-title">
                            {facilityDetails?.ent_name}
                          </h1>
                          {documentEnabled === "Y" &&
                            <h1 className="main-title">
                              {facilityDetails?.ent_occupation}
                            </h1>}
                          {documentEnabled === "Y" &&
                            <div className="input-item-with-label">
                              <AsyncSelect
                                id="rq_facility_ent_code"
                                name="rq_facility_ent_code"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="300px"
                                value={rqFacilityEntCode}
                                onChange={(selectedOption) => {
                                  try {
                                    handleMedicalRequestData("rq_facility_ent_code", selectedOption.value);
                                    handleMedicalRequestData("rq_facility_aent_code", selectedOption.ent_aent_code);
                                    handleMedicalRequestData("rq_facility_name", selectedOption.label);
                                    setFacilityDetails(selectedOption);
                                    setRqFacilityEntCode(selectedOption);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                loadOptions={fetchEntityBySearch}
                                isSearchable={true}
                                placeholder="Facility"
                              />
                            </div>}
                        </div>
                        <div className="email-phone-row">
                          <span className="email-phone-details" style={{ cursor: "pointer" }}
                            onClick={() => {
                              try {
                                setEmailData({
                                  to: facilityDetails?.ent_email,
                                  cc: "",
                                  bcc: "",
                                  subject: "",
                                  show_attach: "Y",
                                  attached_urls: [],
                                  binary_docs: [],
                                  doc_no: rqCode,
                                  doc_type: "Medical Request",
                                  doc_id: medicalRequestId,
                                  entity_codes: [rqFacilityEntCode?.value],
                                  search_string: rqFacilityEntCode?.label + "," + rqCode,
                                  carrierName: "",
                                  productName: "",
                                  clientName: rqFacilityEntCode?.label,
                                  riskNoteNo: rqCode,
                                  daysToRenewal: 0,
                                  expiryDate: null,
                                  insuredName: rqFacilityEntCode?.label,
                                  outstandingPremium: null,
                                  policyCurrency: null,
                                  policyNumber: null,
                                  policyPremium: null,
                                  policyPremiumTotal: null,
                                  policySumFacility: null,
                                  policyFromDate: null,
                                  policyToDate: null,
                                  tpt_category: []
                                });
                                setEmailDialogOpen(true);
                              } catch (error) {
                                console.log(error)
                              }
                            }}>
                            <EmailIcon className="icon" /> <h1 className="sub-title">{facilityDetails?.ent_email || "Missing"}</h1>
                          </span>
                          <span className="email-phone-details">
                            <LocalPhoneIcon className="icon" /> <h1 className="sub-title">{facilityDetails?.ent_phone_no || "Missing"}</h1>
                          </span>
                          <span className="email-phone-details">
                            <TbCertificate className="icon" /> <h1 className="sub-title">{facilityDetails?.aent_name_xx || "Missing"}</h1>
                          </span>
                          <span className="email-phone-details"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              try {
                                navigate(`/entity/${facilityDetails?._id}`, {
                                  state: { shouldFetchClients: false },
                                });
                              } catch (error) {
                                console.log(error)
                              }
                            }}>
                            <TagIcon className="icon" /> <h1 className="sub-title">{facilityDetails?.ent_code}</h1>
                          </span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </ExpandableComponent>
              {/* facility details end here */}
              <hr className="separator-h" />
              {documentEnabled === "Y" &&
                <div className="input-item-with-label" style={{ display: "flex", width: "100%", flexDirection: "column", marginTop: "10px", gap: "10px" }}>
                  <label htmlFor="rq_narration" style={{ width: "max-content", alignSelf: "flex-start" }}>
                    NARRATION
                  </label>
                  <textarea
                    id="rq_narration"
                    name="rq_narration"
                    type="text"
                    placeholder="REMARKS"
                    value={rqNarration}
                    className="form-input-item"
                    style={{ width: "100%" }}
                    rows={3}
                    onChange={(e) => {
                      try {
                        setRqNarration(e.target.value)
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                    disabled={documentEnabled === "N"}
                  />
                </div>}
              {documentEnabled === "N" && rqNarration &&
                <div className="content-details-row">
                  <h1 className="sub-title">{`NARRATION: ${rqNarration}`}</h1>
                </div>}
              <hr className="separator-h" />
              <ExpandableComponent
                title="TESTS TO PERFORM"
                subtitle={null}
                onSubtitleClick={null}
                bgColor="#fff"
                defaultExpanded={true}
              >
                <div className="medical-tests-wrapper">
                  <div className="mtests-wrapper-row">
                    <div className="input-item-with-label">
                      <label htmlFor="rq_mr_code" style={{ width: "max-content" }}>CATEGORY</label>
                      <Select
                        id="rq_mr_code"
                        name="rq_mr_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width={"300px"}
                        value={rqMrCode}
                        onChange={(selectedOption) => {
                          try {
                            handleMedicalRequestData("rq_mr_code", selectedOption.value);
                            setRqMrCode(selectedOption);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        // onBlur={async () => {
                        //   try {
                        //     await saveRecord();
                        //     fetchMedicalRequest();
                        //   } catch (error) {
                        //     console.log(error);
                        //   }
                        // }}
                        options={medicalReviewClasses}
                        isSearchable={true}
                        isDisabled={documentEnabled === "N"}
                        placeholder="TEST CATEGORY"
                      />
                    </div>

                    <div className="input-item-with-label" >
                      <label htmlFor="rq_expected_return" className="form-input-label" style={{ width: "max-content" }}>
                        RETURN DATE
                      </label>
                      <input
                        name="rq_expected_return"
                        type="date"
                        placeholder="EXPECTED RETURN DATE"
                        className="form-input-item"
                        style={{ width: "140px" }}
                        value={rqExpectedReturn}
                        onChange={(e) => {
                          try {
                            const formattedDate = moment(e.target.value).format(
                              "YYYY-MM-DD"
                            );
                            handleMedicalRequestData("rq_expected_return", formattedDate);
                            setRqExpectedReturn(formattedDate);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        disabled={documentEnabled === "N"}
                      />
                    </div>

                    <div className="input-item-with-label" >
                      <label htmlFor="rq_done_on" className="form-input-label" style={{ width: "max-content" }}>
                        TEST DONE ON
                      </label>
                      <input
                        name="rq_done_on"
                        type="date"
                        placeholder="TEST DONE ON"
                        className="form-input-item"
                        style={{ width: "140px" }}
                        value={rqDoneOn}
                        onChange={(e) => {
                          try {
                            const formattedDate = moment(e.target.value).format(
                              "YYYY-MM-DD"
                            );
                            handleMedicalRequestData("rq_done_on", formattedDate);
                            setRqDoneOn(formattedDate);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        disabled={documentEnabled === "N"}
                      />
                    </div>
                  </div>
                  <div className="medical-tests-wrapper">
                    <div className="mtests-wrapper">
                      {medicalTestsToPerform?.length > 0 && (
                        <>
                          {medicalTestsToPerform?.map((row, index) => (
                            <div key={row._id} className="single-item">
                              <span
                                style={{
                                  alignContent: "flex-start",
                                  fontWeight: "bold",
                                  fontSize: "20px",
                                }}
                              >
                                {index + 1}.
                              </span>
                              <div className="mtest">
                                <span className="mtest-name">
                                  {row.test_desc}
                                </span>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </ExpandableComponent>
            </div>
          </div>
          <div className="right-wrapper">
            <div className="right-content">
              <WorkedOnBy name={medicalRequestData?.updated_by_name_xx} photoUrl={medicalRequestData?.updated_by_photo_url_xx} time_ago_xx={medicalRequestData?.time_ago_xx} />
              <hr className="separator-h" />
              <h1 className="main-title">TIMELINE</h1>
              <hr className="separator-h" />
              <div className="timeline-root">
                {timeline?.map((item) => (
                  <div key={item?._id} className="timeline-item">
                    <div className="timeline-separator">
                      <div className="timeline-dot"></div>
                      <div className="timeline-connector"></div>
                    </div>
                    <div className="timeline-content">
                      <div className="timeline-navbar">
                        <div className="avatar-container">
                          {item?.action_by_photo_url_xx ?
                            <img src={item?.action_by_photo_url_xx} alt="" className="avatar" /> : <BrokenImageOutlinedIcon style={{ width: "30px", height: "30px" }} />}
                          <span className="username">{item?.action_by_name_xx}</span>
                        </div>
                        <span className="time-ago">{item?.time_ago_xx}</span>
                      </div>
                      <div className="remarks">
                        {item?.action_text}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">EMAIL</h1>
              <CircularButton onClick={() => setEmailDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} currentTheme={currentTheme} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">Reports</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={medicalRequestData?.report_keys_array}
                documentData={{
                  docNo: rqCode,
                  docType: "Medical Request",
                  docId: medicalRequestId,
                  request_docid: medicalRequestId,
                  clientEmail: insuredDetails?.ent_email,
                  clientEntCode: insuredDetails?.ent_code,
                  clientEntName: insuredDetails?.ent_name
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeText(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
    </motion.div>
  );
};

export default UwMedicalSingle;
